import React, { createContext, useContext, useState } from "react";
import { useTelegram } from "../hooks/useTelegram"


// Create the context
const ItemContext = createContext();

// Provider component
export const ItemProvider = ({ children }) => {
    const { tg, triggerHapticFeedback } = useTelegram();
    const [cartItems, setCartItems] = useState([]);
    const [showNotification, setShowNotification] = useState(false);

    const handleAddToCart = (item) => {
        triggerHapticFeedback('selection');
        if (cartItems.length > 0 && cartItems[0].gameId !== item.gameId) {
            setShowNotification(true);
            setTimeout(() => setShowNotification(false), 6000); // Auto-hide notification after 3 seconds     
        } else {
            const existingItem = cartItems.find((cartItem) => cartItem.itemId === item.itemId);
            setShowNotification(false);
            if (existingItem) {
                setCartItems(
                    cartItems.map((cartItem) =>
                        cartItem.itemId === item.itemId
                            ? {
                                ...cartItem,
                                quantity: cartItem.quantity + 1,
                                summedPriceAfterDiscount: (cartItem.quantity + 1) * Number(cartItem.priceAfterDiscount),
                                summedPrice: (cartItem.quantity + 1) * Number(cartItem.price),
                            }
                            : cartItem
                    )
                );
            } else {
                setCartItems([
                    ...cartItems,
                    {
                        gameId: item.gameId,
                        haveSuperCell: item.haveSuperCell,
                        itemId: item.itemId,
                        parentFileName: item.parentFileName,
                        quantity: 1,
                        noLogin: item.noLogin,
                        price: Number(item.price),
                        priceAfterDiscount: Number(item.priceAfterDiscount),
                        name: item.name,
                        fileName: item.fileName,
                        summedPriceAfterDiscount: Number(item.priceAfterDiscount),
                        summedPrice: Number(item.price),
                    },
                ]);
            }
        }
    };

    const handleRemoveFromCart = (item) => {
        triggerHapticFeedback('selection');
        const existingItem = cartItems.find((cartItem) => cartItem.itemId === item.itemId);

        if (existingItem.quantity > 1) {
            setCartItems((prevCartItems) =>
                prevCartItems.map((cartItem) =>
                    cartItem.itemId === item.itemId
                        ? {
                            ...cartItem,
                            quantity: cartItem.quantity - 1,
                            summedPriceAfterDiscount: (cartItem.quantity - 1) * Number(cartItem.priceAfterDiscount),
                            summedPrice: (cartItem.quantity - 1) * Number(cartItem.price),
                        }
                        : cartItem
                )
            );
        } else {
            setCartItems((prevCartItems) =>
                prevCartItems.filter((cartItem) => cartItem.itemId !== item.itemId)
            );
        }
    };

    const handleClearCart = () => {

        triggerHapticFeedback('impact', 'medium')
        setCartItems([]);
        setShowNotification(false)
    };

    return (
        <ItemContext.Provider
            value={{
                cartItems,
                setCartItems,
                handleAddToCart,
                handleRemoveFromCart,
                handleClearCart,
                showNotification
            }}
        >
            {children}
        </ItemContext.Provider>
    );
};

// Hook to use the context
export const useItemContext = () => useContext(ItemContext);
